export default __webpack_public_path__ + "static/media/logo-passenger.d3afd408.svg";